import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../store/state/app.state';
import {environment} from '../../environments/environment';
import {selectCID} from '../store/selectors/page.selectors';

@Injectable({
  providedIn: 'root'
})
export class UrlControllerService {

  public pageCID$: Observable<string>;

  /**
   * Url of api
   */
  private apiUrl: string;
  private statsUrl: string;

  get apiUrlSelected(): string {
    return this.apiUrl;
  }

  set apiUrlSelected(url: string) {
    this.apiUrl = url;
  }

  get statsUrlSelected(): string {
    return this.statsUrl;
  }

  set statsUrlSelected(url: string) {
    this.statsUrl = url;
  }

  constructor(public _store: Store<IAppState>) {
    this.pageCID$ = this._store.pipe(select(selectCID));
    this.pageCID$.subscribe((CID) => {
      if (CID && environment.apiUrl[CID]) {
        this.apiUrlSelected = environment.apiUrl[CID];
      } else {
        this.apiUrlSelected = environment.apiUrl.default;
      }
      if (CID && environment.urlStats[CID]) {
        this.statsUrlSelected = environment.urlStats[CID];
      } else {
        this.statsUrlSelected = environment.urlStats.default;
      }
    });
  }

}
